import moment from 'moment'

export function getTimezoneOffset(tz, hereDate) {
  hereDate = new Date(hereDate || Date.now())
  hereDate.setMilliseconds(0) // for nice rounding

  const hereOffsetHrs = (hereDate.getTimezoneOffset() / 60) * -1,
    thereLocaleStr = hereDate.toLocaleString('en-US', { timeZone: tz }),
    thereDate = new Date(thereLocaleStr),
    diffHrs = (thereDate.getTime() - hereDate.getTime()) / 1000 / 60 / 60,
    thereOffsetHrs = hereOffsetHrs + diffHrs

  return thereOffsetHrs
}

export function formatTimezoneOptionsDescription(localTimezoneHours) {
  const minutesInDecimal = localTimezoneHours - Math.floor(localTimezoneHours),
    minutes = minutesInDecimal === 0.5 ? 30 : 0,
    plusMinus = localTimezoneHours >= 0 ? '+' : '-',
    hours = localTimezoneHours >= 0 ? `+${localTimezoneHours}` : localTimezoneHours,
    hoursToTime = moment(`${localTimezoneHours}:${minutes}`, 'HH:mm').format('HH:mm')

  return `GTM ${hours} (UTC${plusMinus}${hoursToTime})`
}

export const defaultDateRanges = Object.freeze({
  today: 'Today',
  yesterday: 'Yesterday',
  dayBeforeYesterday: 'Day before yesterday',
  lastSevenDays: 'Last 7 days',
  previousMonth: 'Previous month',
  tomorrow: 'Tomorrow',
  upcomingSevenDays: 'Upcoming 7 days',
  custom: 'Custom',
})

export const defaultFilters = Object.freeze({
  dateOfBookingCreation: 'BookingCreationDate',
  dateOfVisitBooking: 'BookingVisitDate',
  dateOfPaymentCreation: 'PaymentCreationDate',
  dateOfPaymentStatus: 'PaymentStatusDate',
})

export const defaultFiltersLabels = Object.freeze({
  dateOfBookingCreation: 'Date of booking',
  dateOfVisitBooking: 'Date of visit',
  dateOfPaymentCreation: 'Date of payment',
  dateOfPaymentStatus: 'Date of payment status',
})
